<div class="avatar-wrapper">

    <ngx-avatar *ngIf="editable" [round]="round" initialsSize="2" (click)="fileInput.click()" [name]="_clientName" [src]="_src"></ngx-avatar>
    <ngx-avatar *ngIf="!editable" [round]="round" initialsSize="2" [name]="_clientName" [src]="_src"></ngx-avatar>
    <!-- IconButton do DS (sm, redondo por estar sobre o avatar) -->
    <button *ngIf="excludable" type="button" (click)="deleteImage()" class="oa-icon-btn oa-icon-btn--sm oa-icon-btn--danger image-field-btn image-field-btn--delete"
        aria-label="Remover foto" matTooltip="Remover foto">
        <mat-icon>delete</mat-icon>
    </button>

    <button *ngIf="editable" type="button" (click)="fileInput.click()" class="oa-icon-btn oa-icon-btn--sm image-field-btn image-field-btn--edit"
        aria-label="Alterar foto" matTooltip="Alterar foto">
        <mat-icon>edit</mat-icon>
    </button>
</div>
<input #fileInput (change)="fileChange($event)" hidden type="file" name="image" [accept]="accept">
